/* tslint:disable */

export const BASE_URL = '/lcm/crepo';

export const REPOSITORY_URL = `${BASE_URL}/api/repository`;

export const GET_CHILDREN_NODES_URL = (parentId: string) =>
  `${BASE_URL}/api/content/nodes/children/${parentId}`;

export const DOWNLOAD_FOLDER_URL = `${BASE_URL}/api/contents/download`;
